// ##############################
// // // ChartCard styles
// #############################

import {
  card,
  cardHeader,
  defaultFont,
  orangeCardHeader,
  greenCardHeader,
  redCardHeader,
  blueCardHeader,
  purpleCardHeader,
  cardActions,
  grayColor,
  warningColor,
  dangerColor,
  successColor,
  infoColor,
  primaryColor,
  roseColor
} from 'assets/jss/styles.jsx'

const chartCardStyle = {
  blueCardHeader,
  card,
  cardActions: {
    ...cardActions,
    padding: '0!important'
  },
  cardCategory: {
    color: grayColor,
    marginBottom: '0',
    ...defaultFont,
    fontSize: '0.9em'
  },
  cardContent: {
    padding: '15px 20px'
  },
  cardHeader: {
    ...cardHeader,
    minHeight: '160px',
    padding: '0',
    ...defaultFont
  },
  cardStats: {
    color: grayColor,
    display: 'inline-block',
    fontSize: '12px',
    lineHeight: '22px',
    margin: '0!important'
  },
  cardStatsIcon: {
    height: '16px',
    position: 'relative',
    top: '4px',
    width: '16px'
  },
  cardStatsLink: {
    color: primaryColor,
    textDecoration: 'none',
    ...defaultFont
  },
  cardTitle: {
    marginBottom: '5px',
    marginTop: '0',
    ...defaultFont,
    fontSize: '1.175em'
  },
  dangerCardStatsIcon: {
    color: dangerColor
  },
  grayCardStatsIcon: {
    color: grayColor
  },
  greenCardHeader,
  infoCardStatsIcon: {
    color: infoColor
  },
  orangeCardHeader,
  primaryCardStatsIcon: {
    color: primaryColor
  },
  purpleCardHeader,
  redCardHeader,
  roseCardStatsIcon: {
    color: roseColor
  },
  successCardStatsIcon: {
    color: successColor
  },
  warningCardStatsIcon: {
    color: warningColor
  }
}

export default chartCardStyle



// WEBPACK FOOTER //
// ./src/assets/jss/dashboard/chartCardStyle.jsx